module.exports = __webpack_public_path__ + "static/media/cat3.14b8bdb7.png";